import { render, staticRenderFns } from "./EmLocationList.vue?vue&type=template&id=364bface&"
import script from "./EmLocationList.vue?vue&type=script&lang=js&"
export * from "./EmLocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports